import { Button } from "../ui/button";
import { CheckCircle } from "lucide-react";
import { format } from "date-fns";
const SuccessScreen = ({ formData, onReset, schedulerSettings = null }) => {
  const markAsScheduled = schedulerSettings?.mark_as_scheduled === 0;
  const totalCost = formData.servicePrices
    ? Object.values(formData.servicePrices).reduce((sum, price) => {
        const numericPrice = Number(price);
        return sum + (Number.isFinite(numericPrice) ? numericPrice : 0);
      }, 0)
    : 0;
  const formattedDate = formData.appointmentDate
    ? format(formData.appointmentDate, "MM/dd/yyyy")
    : "";
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="rounded-full bg-green-50 p-4 mb-6">
        <CheckCircle size={48} className="text-green-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">
        {markAsScheduled ? "Submitted Successfully" : "Appointment Confirmed!"}
      </h2>
      <p className="text-gray-600 mb-8 max-w-md">
        {markAsScheduled
          ? "Your inspection request has been successfully submitted. Someone from the inspection company will contact you soon to confirm the booking or request any additional information."
          : `Your inspection has been scheduled for ${formattedDate} at ${formData.appointmentTime}. We've sent a confirmation email to ${formData.email}.`}
      </p>
      <div className="bg-gray-50 w-full max-w-md rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Appointment Details</h3>
        <div
          className="space-y-3"
          style={{
            color: "#3B3B3B",
            fontFamily: '"Open Sans"',
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "22px",
          }}
        >
          <div className="flex justify-between">
            <span className="text-gray-600">Date:</span>
            <span className="font-medium">{formattedDate}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Time:</span>
            <span className="font-medium">{formData.appointmentTime}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Location:</span>
            <span className="font-medium">
              {formData.address
                ? `${formData.address}, ${formData.city}, ${formData.state} ${formData.zipCode}`.trim().replace(/^,\s*|,\s*$/, "")
                : "N/A"}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Services:</span>
            <span className="font-medium text-right">{formData.services.map((id) => formData.serviceNames?.[id] || id).join(", ")}</span>
          </div>
          {totalCost > 0 && (
            <div className="flex justify-between pt-2 border-t border-gray-200">
              <span className="text-gray-600">Total Cost:</span>
              <span className="font-bold">${totalCost.toFixed(2)}</span>
            </div>
          )}
        </div>
      </div>
      <Button type="button" variant="green" className="w-full max-w-md" onClick={onReset}>
        Book Another Inspection
      </Button>
    </div>
  );
};
export default SuccessScreen;
